import { render, staticRenderFns } from "./ProjectCapexPage.vue?vue&type=template&id=07199eaf&scoped=true"
import script from "./ProjectCapexPage.vue?vue&type=script&lang=ts"
export * from "./ProjectCapexPage.vue?vue&type=script&lang=ts"
import style0 from "./ProjectCapexPage.vue?vue&type=style&index=0&id=07199eaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07199eaf",
  null
  
)

export default component.exports